<p-toast key="detailDocument"></p-toast>


<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div #contenu *ngIf="EstCharge()">

    <div class="fluid formgrid grid my-2">
        <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 my-2">
            <label for="lastname">Date<span class="requis">*</span></label>
            <p-calendar appendTo="body" showIcon=true [(ngModel)]="document.date" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040" ></p-calendar>
            <small class="p-error" *ngIf="submitted && !document.date">La date est obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 my-2">
            <label for="nom">Nom<span class="requis">*</span></label>
            <input id="nom" type="text" pInputText 
                [(ngModel)]="document.nom" autofocus>
                <small class="p-error" *ngIf="submitted && !document.nom">Le nom est obligatoire.</small>
        </div>
        <div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 my-2">
            <label for="type">Visibilité <i pTooltip="Ce bouton permet de contrôler si le document est accessible à quiconque via son URL publique" class="pi pi-question-circle"></i></label>
            <p-toggleButton 
                [(ngModel)]="document.public" 
                onLabel="Public" 
                offLabel="Privé" />
        </div>
    </div>


    <div class="fluid formgrid grid my-2">

        <div class="flex flex-column gap-2 col-12">
            <label for="description">Description</label>
            <textarea id="description" rows="3" pInputTextarea
                [(ngModel)]="document.description"></textarea>
        </div>
    </div>

    <div class="fluid formgrid grid my-2" *ngIf="document.public">
        <div class="flex flex-column col-12 gap-2">
            <label>URL publique <i pTooltip="Ce lien permet d'accéder au document sans authentification" class="pi pi-globe"></i></label>
            <div class="flex align-items-center gap-2">
                <div class="flex-grow-1 p-inputgroup">
                    <input id="publicUrl" type="text" pInputText [value]="getPublicUrl()" readonly class="text-sm w-full">
                    <button pButton icon="pi pi-copy" type="button" (click)="copyPublicUrl()" pTooltip="Copier l'URL" tooltipPosition="top"></button>
                </div>
            </div>
        </div>
    </div>

    <div class="text-right my-2">

        <button pButton pRipple label="Sauvegarder" icon="pi pi-save" class="p-button-primary"
        (click)="sauvegarder()"></button>
        <button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text" (click)="annuler()"></button>
        

    </div>

</div>